/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Structured_Import_ExportInputs */

const en_directory_agent_readiness_check_structured_import_export = /** @type {(inputs: Directory_Agent_Readiness_Check_Structured_Import_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured import and export`)
};

const zh_directory_agent_readiness_check_structured_import_export = /** @type {(inputs: Directory_Agent_Readiness_Check_Structured_Import_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结构化导入与导出`)
};

/**
* | output |
* | --- |
* | "Structured import and export" |
*
* @param {Directory_Agent_Readiness_Check_Structured_Import_ExportInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_structured_import_export = /** @type {((inputs?: Directory_Agent_Readiness_Check_Structured_Import_ExportInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Structured_Import_ExportInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_structured_import_export(inputs)
	return zh_directory_agent_readiness_check_structured_import_export(inputs)
});
export { directory_agent_readiness_check_structured_import_export as "directory.agent_readiness.check.structured_import_export" }